import { IScraperJobConfigurationFragment } from '../graphql/ScraperJobConfigurationFragment'

export const groupJobConfigsByTms = (data: IScraperJobConfigurationFragment[]) => {
  const groupedObjects: { [key: string]: IScraperJobConfigurationFragment[] } = {}

  // Group objects by tms field
  data.forEach(obj => {
    const { tmsName } = obj
    if (groupedObjects[tmsName]) {
      groupedObjects[tmsName].push(obj)
    } else {
      groupedObjects[tmsName] = [obj]
    }
  })

  // Convert the groupedObjects object to an array of arrays
  const result: IScraperJobConfigurationFragment[][] = Object.values(groupedObjects)
  // tmsName will not differ among elements of the same subarray
  const sortedResult = result.sort((a, b) => a[0].tmsName.localeCompare(b[0].tmsName))
  return sortedResult
}
